module.exports = __webpack_public_path__ + "img/ics_f_thumb-good-white.4b229e17.svg";